import { useIntl } from 'react-intl';
import type { PublicAssetShare } from 'fym-shared/src/music24/assetShares';
import { assetShareMessages } from './assetShareMessages';

/** The label of the shared file for a screen reader: "AI reel 15s of Forests by LaziiBee". */
export function useShareMediaLabel(share: PublicAssetShare): string {
  const intl = useIntl();
  return intl.formatMessage(assetShareMessages.mediaLabel, {
    asset: share.assetLabel,
    song: share.song.title,
    artist: share.artist.name,
  });
}
